import moment from "moment-jalaali";
import config from '../config.json';
moment.loadPersian({ dialect: 'persian-modern' })

export const genDateTime = (format) => {

    const result = {}
    try {
        let timeZone = config.timeZone;
        const currentTimeStamp = Date.now();

        if (timeZone === 'GMT+3:30') {
            result.dateTimeStr = moment(currentTimeStamp).utc(false).add('3.5', 'hours').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = currentTimeStamp;
        }
        else if (timeZone === 'GMT+4:30') {
            result.dateTimeStr = moment(currentTimeStamp).utc(false).add('4.5', 'hours').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = currentTimeStamp;
        }
        else {
            result.dateTimeStr = moment(currentTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = currentTimeStamp;
        }

    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        const currentTimeStamp = Date.now();
        result.dateTimeStr = moment(currentTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
        result.timeStamp = currentTimeStamp;
    }
    return result;
}
export const subtractDays = (timeStamp, days, format) => {
    const result = {};
    try {
        let timeZone = config.timeZone;

        if (timeZone === 'GMT+3:30') {
            result.dateTimeStr = moment(timeStamp).utc(false).add('3.5', 'hours').subtract(days, 'days').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(timeStamp).utc(false).add('3.5', 'hours').subtract(days, 'days').subtract('3.5', 'hours').unix() * 1000;
        }
        else if (timeZone === 'GMT+4:30') {
            result.dateTimeStr = moment(timeStamp).utc(false).add('4.5', 'hours').subtract(days, 'days').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(timeStamp).utc(false).add('4.5', 'hours').subtract(days, 'days').subtract('4.5', 'hours').unix() * 1000;
        }
        else {
            result.dateTimeStr = moment(timeStamp).subtract(days, 'days').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(timeStamp).subtract(days, 'days').unix() * 1000;
        }

    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        result.dateTimeStr = moment(timeStamp).subtract(days, 'days').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
        result.timeStamp = moment(timeStamp).subtract(days, 'day').unix() * 1000;
    }
    return result;
}
export const addDays = (timeStamp, days, format) => {
    const result = {};
    try {
        let timeZone = config.timeZone;

        if (timeZone === 'GMT+3:30') {
            result.dateTimeStr = moment(timeStamp).utc(false).add('3.5', 'hours').add(days, 'days').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(timeStamp).utc(false).add('3.5', 'hours').add(days, 'days').subtract('3.5', 'hours').unix() * 1000;
        }
        else if (timeZone === 'GMT+4:30') {
            result.dateTimeStr = moment(timeStamp).utc(false).add('4.5', 'hours').add(days, 'days').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(timeStamp).utc(false).add('4.5', 'hours').add(days, 'days').subtract('4.5', 'hours').unix() * 1000;
        }
        else {
            result.dateTimeStr = moment(timeStamp).add(days, 'days').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(timeStamp).add(days, 'days').unix() * 1000;
        }

    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        result.dateTimeStr = moment(timeStamp).add(days, 'days').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
        result.timeStamp = moment(timeStamp).add(days, 'days').unix() * 1000;
    }
    return result;
}
export const genSpecificDateTime = (dateIso, format) => {
    const result = {}
    try {
        let timeZone = config.timeZone;
        const targetTimeStamp = moment(dateIso).unix() * 1000;

        if (timeZone === 'GMT+3:30') {
            result.dateTimeStr = moment(targetTimeStamp).utc(false).add('3.5', 'hours').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = targetTimeStamp;
        }
        else if (timeZone === 'GMT+4:30') {
            result.dateTimeStr = moment(targetTimeStamp).utc(false).add('4.5', 'hours').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = targetTimeStamp;
        }
        else {
            result.dateTimeStr = moment(targetTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = targetTimeStamp;
        }

    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        const targetTimeStamp = moment(dateIso).unix() * 1000;
        result.dateTimeStr = moment(targetTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
        result.timeStamp = targetTimeStamp;
    }
    return result;
}
export const subtractMonths = (timeStamp, months, format) => {
    const result = {};
    try {
        let timeZone = config.timeZone;

        if (timeZone === 'GMT+3:30') {
            result.dateTimeStr = moment(timeStamp).utc(false).add('3.5', 'hours').subtract(months, 'month').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(timeStamp).utc(false).add('3.5', 'hours').subtract(months, 'month').subtract('3.5', 'hours').unix() * 1000;
        }
        else if (timeZone === 'GMT+4:30') {
            result.dateTimeStr = moment(timeStamp).utc(false).add('4.5', 'hours').subtract(months, 'month').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(timeStamp).utc(false).add('4.5', 'hours').subtract(months, 'month').subtract('4.5', 'hours').unix() * 1000;
        }
        else {
            result.dateTimeStr = moment(timeStamp).subtract(months, 'month').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(timeStamp).subtract(months, 'month').unix() * 1000;
        }

    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        result.dateTimeStr = moment(timeStamp).subtract(months, 'month').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
        result.timeStamp = moment(timeStamp).subtract(months, 'month').unix() * 1000;
    }
    return result;
}
export const genDateTimeByDateStr = (dateStr, format) => {
    const result = {}
    try {
        let timeZone = config.timeZone;
        const thisMonth = moment(dateStr, format).jMonth();

        if (timeZone === 'GMT+3:30') {
            if(thisMonth < 6){
                const targetTimeStamp = moment(dateStr, format).utc(false).add('1', 'hour').unix() * 1000;
                result.dateTimeStr = moment(targetTimeStamp).utc(false).add('3.5', 'hours').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
                result.timeStamp = targetTimeStamp;
            }
            else{
                const targetTimeStamp = moment(dateStr, format).utc(false).unix() * 1000;
                result.dateTimeStr = moment(targetTimeStamp).utc(false).add('3.5', 'hours').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
                result.timeStamp = targetTimeStamp;
            }
        }
        else if (timeZone === 'GMT+4:30') {
            if(thisMonth > 6){
                const targetTimeStamp = moment(dateStr, format).utc(false).subtract('1', 'hour').unix() * 1000;
                result.dateTimeStr = moment(targetTimeStamp).utc(false).add('4.5', 'hours').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
                result.timeStamp = targetTimeStamp;
            }
            else{
                const targetTimeStamp = moment(dateStr, format).utc(false).unix() * 1000;
                result.dateTimeStr = moment(targetTimeStamp).utc(false).add('4.5', 'hours').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
                result.timeStamp = targetTimeStamp;
            }
        }
        else {
            const targetTimeStamp = moment(dateStr, format).unix() * 1000;
            result.dateTimeStr = moment(targetTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = targetTimeStamp;
        }

    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        const targetTimeStamp = moment(dateStr, format).unix() * 1000;
        result.dateTimeStr = moment(targetTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
        result.timeStamp = targetTimeStamp;
    }
    return result;
}
export const genDateTimeStartOfDay = (dateIso, format) => {
    const result = {}
    try {
        let timeZone = config.timeZone;
        
        if (timeZone === 'GMT+3:30') {
            const targetTimeStamp = moment(dateIso).utc(false).add('3.5', 'hours').startOf('day').subtract('3.5', 'hours').unix() * 1000
            result.dateTimeStr = moment(targetTimeStamp).utc(false).add('3.5', 'hours').startOf('day').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = targetTimeStamp;
        }
        else if (timeZone === 'GMT+4:30') {
            const targetTimeStamp = moment(dateIso).utc(false).add('4.5', 'hours').startOf('day').subtract('4.5', 'hours').unix() * 1000
            result.dateTimeStr = moment(targetTimeStamp).utc(false).add('4.5', 'hours').startOf('day').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = targetTimeStamp;
        }
        else {
            const targetTimeStamp = moment(dateIso).startOf('day').unix() * 1000
            result.dateTimeStr = moment(targetTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(targetTimeStamp).startOf('day').unix() * 1000;
        }



    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        const targetTimeStamp = moment(dateIso).startOf('day').unix() * 1000
        result.dateTimeStr = moment(targetTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
        result.timeStamp = moment(targetTimeStamp).startOf('day').unix() * 1000;
    }
    return result;
}
export const genDateTimeEndOfDay = (dateIso, format) => {
    const result = {}
    try {
        let timeZone = config.timeZone;
        
        if (timeZone === 'GMT+3:30') {
            const targetTimeStamp = moment(dateIso).utc(false).add('3.5', 'hours').endOf('day').subtract('3.5', 'hours').unix() * 1000
            result.dateTimeStr = moment(targetTimeStamp).utc(false).add('3.5', 'hours').endOf('day').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = targetTimeStamp;
        }
        else if (timeZone === 'GMT+4:30') {
            const targetTimeStamp = moment(dateIso).utc(false).add('4.5', 'hours').endOf('day').subtract('4.5', 'hours').unix() * 1000
            result.dateTimeStr = moment(targetTimeStamp).utc(false).add('4.5', 'hours').endOf('day').format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = targetTimeStamp;
        }
        else {
            const targetTimeStamp = moment(dateIso).endOf('day').unix() * 1000
            result.dateTimeStr = moment(targetTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
            result.timeStamp = moment(targetTimeStamp).endOf('day').unix() * 1000;
        }



    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        const targetTimeStamp = moment(dateIso).endOf('day').unix() * 1000
        result.dateTimeStr = moment(targetTimeStamp).format(format || 'jYYYY/jMM/jDD HH:mm:ss')
        result.timeStamp = moment(targetTimeStamp).endOf('day').unix() * 1000;
    }
    return result;
}


export const genReportCalendarDateTime = () => {

    const result = {}
    try {
        let timeZone = config.timeZone;
        const currentTimeStamp = Date.now();


        if (timeZone === 'GMT+3:30') {
            result.startOfDay = new Date(moment(currentTimeStamp).utc(false).add('3.5', 'hour').startOf('day').subtract('3.5', 'hours').unix() * 1000);
            result.endOfDay = new Date(moment(currentTimeStamp).utc(false).add('3.5', 'hour').endOf('day').subtract('3.5', 'hours').unix() * 1000);
        }
        else if (timeZone === 'GMT+4:30') {
            result.startOfDay = new Date(moment(currentTimeStamp).utc(false).add('4.5', 'hour').startOf('day').subtract('4.5', 'hours').unix() * 1000);
            result.endOfDay = new Date(moment(currentTimeStamp).utc(false).add('4.5', 'hour').endOf('day').subtract('4.5', 'hours').unix() * 1000);
        }
        else {
        result.startOfDay = new Date(moment(currentTimeStamp).startOf('day').unix() * 1000);
        result.endOfDay = new Date(moment(currentTimeStamp).endOf('day').unix() * 1000);
        }

    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        const currentTimeStamp = Date.now();
        result.startOfDay = new Date(moment(currentTimeStamp).startOf('day').unix() * 1000);
        result.endOfDay = new Date(moment(currentTimeStamp).endOf('day').unix() * 1000);
    }
    return result;
}
export const genShoppingCartCookie2DaysmExpireTime = () => {

    const result = {}
    try {
        let timeZone = config.timeZone;
        const currentTimeStamp = Date.now();

        if (timeZone === 'GMT+3:30') {
            result.dateTime = moment(currentTimeStamp).utc(false).add('3.5', 'hours').add('2', 'days').subtract('3.5', 'hours');
        }
        else if (timeZone === 'GMT+4:30') {
            result.dateTime = moment(currentTimeStamp).utc(false).add('4.5', 'hours').add('2', 'days').subtract('4.5', 'hours');
        }
        else {
            result.dateTime = moment(currentTimeStamp).add('10', 'minutes');
        }

    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        const currentTimeStamp = Date.now();
        result.dateTime = moment(currentTimeStamp).add('10', 'minutes');
    }
    return result;
}

export const genReportCalendarDateTimeStamp = () => {

    const dateIso = new Date();
    const result = {}
    try {

        let timeZone = config.timeZone;

        if (timeZone === 'GMT+3:30') {
            result.startOfDay  = moment(dateIso).utc(false).add('3.5', 'hours').startOf('day').subtract('3.5', 'hours').unix() * 1000
            result.endOfDay  = moment(dateIso).utc(false).add('3.5', 'hours').endOf('day').subtract('3.5', 'hours').unix() * 1000
            
        }
        else if (timeZone === 'GMT+4:30') {
            result.startOfDay = moment(dateIso).utc(false).add('4.5', 'hours').startOf('day').subtract('4.5', 'hours').unix() * 1000
            result.endOfDay  = moment(dateIso).utc(false).add('4.5', 'hours').endOf('day').subtract('4.5', 'hours').unix() * 1000
        }
        else {
            result.startOfDay = moment(dateIso).startOf('day').unix() * 1000;
            result.endOfDay = moment(dateIso).endOf('day').unix() * 1000;
        }

        
    } catch (err) {
        const error = new Error(err);
        console.log(error.stack)
        const currentTimeStamp = Date.now();
        result.startOfDay = moment(currentTimeStamp).startOf('day').unix() * 1000;;
        result.endOfDay = moment(currentTimeStamp).endOf('day').unix() * 1000;
    }
    return result;
}
export const isElectronOnFirst6Month = (timeStamp) => {
    const thisMonth = moment(timeStamp).jMonth();
    if(thisMonth < 6 && navigator.userAgent.includes('Electron/16.2.8')){
        return true;
    }
    else{
        return false;
    }
    
}
